import { HttpHeaders } from "../../../utils/http-utils";
import { axiosInstance as axios } from "./axios-provider";
import { ErrorHandler } from "./error-handler";

export class TransformerService {
  private readonly transformationConfig: {
    baseURL: string;
    headers: HttpHeaders;
  };

  constructor(
    private readonly baseURL: string,
    private readonly sctToJsonPath: string
  ) {
    this.transformationConfig = {
      baseURL: this.baseURL,
      headers: {
        "Content-Type": "application/xml",
      },
    };
  }

  private errorHandler = new ErrorHandler("Transformer service");

  async transform(data: string): Promise<string> {
    const response = await axios.post(this.sctToJsonPath, data, this.transformationConfig).catch((e) => {
      this.errorHandler.handle(e, "transformer-service");
      return null;
    });
    return response?.data || null;
  }
}
